import { Component, OnInit } from '@angular/core';
import { IFuenteContrato } from 'src/app/interfaces/fuente-contrato';
import { IPlant } from 'src/app/interfaces/plant';
import { FuenteContratoService } from 'src/app/services/fuente-contrato.service';
import { PlantService } from 'src/app/services/plant.service';
import {Response} from "../../interfaces/response";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FuenteContratoSaveComponent } from './fuente-contrato-save/fuente-contrato-save.component'

@Component({
  selector: 'app-fuente-contrato',
  templateUrl: './fuente-contrato.component.html',
  styleUrls: ['./fuente-contrato.component.css']
})
export class FuenteContratoComponent implements OnInit {

  fuenteContrato: IFuenteContrato[];
  plants: IPlant[];
  lastPage: number;
  sucursal: string;
  nombre_fc: string;
  orden_ceco: number;

  constructor(
    private fuenteContratoService: FuenteContratoService,
    private plantService: PlantService,
    private ngbModalRef: NgbModal
  ) { }

  ngOnInit(): void {
    this.refresh();
    this.getSucursales();
  }
  refresh(currentPage = 1, param1=null , param2=null , param3=null ) {
    this.fuenteContratoService.all(currentPage, param1, param2, param3).subscribe(
      (res: Response) => {
        this.fuenteContrato = res.data;
        this.lastPage = res.meta.last_page;
      }
    )
  }
  getSucursales() {
    this.plantService.allRecords().subscribe(
      (res: Response) => {
        this.plants = res.data;
      }
    )
  }

  delete(id_fc: number) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.fuenteContratoService.delete(id_fc).subscribe(
        res => {
          this.fuenteContrato = this.fuenteContrato.filter(el => el.id_fc !== id_fc);
        }
      );
    }
  }

  mostrarBootstrapModal(id_fc: number,tipo: string) {
    const opts = {
      windowClass: 'myCustomClass'
    };
//
    const modalRefNgBots = this.ngbModalRef.open(FuenteContratoSaveComponent, opts);
//
    modalRefNgBots.componentInstance.id_fc = id_fc;
    modalRefNgBots.componentInstance.tipo = tipo;
//
    modalRefNgBots.componentInstance.closeMyModal = () => {
      modalRefNgBots.close();
    }
//
    modalRefNgBots.componentInstance.salida.subscribe(res => {

     // this.texto = res;
      //console.log('Recibo: ', res.success);
      if (res.success){
        alert("Grabado");
      }
      this.refresh();
      modalRefNgBots.close();
    });

  }

}
